export function initNiceJobSDK(company_public_key: string): void {
    try {
        window.NiceJob.init(company_public_key);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('initNiceJobSDK() error', error);
    }
}
